__turbopack_context__.v({
  "root": "offer-slides-module-scss-module__9ku2cq__root",
  "slide": "offer-slides-module-scss-module__9ku2cq__slide",
  "visible": "offer-slides-module-scss-module__9ku2cq__visible",
});
